export function convertTypeToPlural(str: string): string {
    if (!str.endsWith('s')) {
        return str + 's';
    }
    return str;
}

export function convertTypeToNormal(str: string): string {
    if (str.endsWith('s')) {
        return str.replace(/s$/i, '');
    }
    return str;
}
